function formatScore(score) {
  if (score === null || score === undefined || score === '') return 'Não informado'
  const numericValue = Number(score)
  if (!Number.isFinite(numericValue)) return String(score)
  return `${Math.round(numericValue * 100)}%`
}

export default function DeadlineInterpretedActionsCard({ actions = [] }) {
  return (
    <section className="rules-card deadline-result-section">
      <div className="rules-card-header">
        <div>
          <h3>Ações interpretadas pelo motor</h3>
          <p>Lista retornada em <code>interpretedActions</code>, sem remapeamento no front-end.</p>
        </div>
      </div>
      <div className="rules-card-body">
        {actions.length ? (
          <div className="deadline-task-list">
            {actions.map((action, index) => (
              <article className="deadline-task-item" key={`${action.actionCode || 'action'}-${index}`}>
                <div className="deadline-task-header">
                  <div>
                    <h4>{action.actionName || action.actionCode || 'Ação sem nome'}</h4>
                    <span>{action.actionCode || 'Código não informado'}</span>
                  </div>
                  <span className={`status-badge ${action.requiresHumanReview ? 'is-warning' : 'is-success'}`}>
                    {action.requiresHumanReview ? 'Revisão' : 'OK'} · {formatScore(action.score)}
                  </span>
                </div>
                <dl className="deadline-task-grid">
                  <div><dt>Padrão encontrado</dt><dd>{action.matchedPattern || 'Não informado'}</dd></div>
                  <div><dt>Fonte</dt><dd>{action.source || 'Não informada'}</dd></div>
                  <div><dt>Motivo da revisão</dt><dd>{action.reviewReason || 'Não informado'}</dd></div>
                </dl>
                {action.matchedText ? <blockquote>{action.matchedText}</blockquote> : null}
              </article>
            ))}
          </div>
        ) : <p>Nenhuma ação interpretada foi retornada.</p>}
      </div>
    </section>
  )
}
